module.exports = __webpack_public_path__ + "static/media/Group 7.3150190d.png";